import FieldLabel from "pages/_components/fields/FieldLabel";
import Select from "pages/forms/_components/_fields/Select";
import { arrayOf, bool, func, number, object, oneOfType, shape, string } from "prop-types";
import React, { Component } from "react";

class SelectorInput extends Component {
    inputRef = React.createRef();

    inputGroupRef = React.createRef();

    static propTypes = {
        inputProps: shape({
            name: string.isRequired,
            inputlabelkey: string,
            value: string,
            placeholder: string,
        }),
        isFocused: bool.isRequired,
        onChange: func.isRequired,
        selectProps: shape({
            name: string.isRequired,
            selectLabelKey: string,
            value: oneOfType([string, object]),
            options: arrayOf(
                shape({
                    label: string.isRequired,
                    value: string.isRequired,
                }),
            ),
        }),
        toggleIsFocused: func.isRequired,
        onBlur: func,
        inputMaxLength: number,
        idField: string.isRequired,
    };

    static defaultProps = {
        onBlur: () => {},
        inputProps: {},
        selectProps: {},
        inputMaxLength: undefined,
    };

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClick, false);
    }

    handleClick = ({ target }) => {
        const { isFocused, toggleIsFocused, onBlur } = this.props;

        if (this.inputGroupRef.current.contains(target) && !isFocused) {
            toggleIsFocused();
        }

        if (!this.inputGroupRef.current.contains(target) && isFocused) {
            toggleIsFocused();
            onBlur();
        }
    };

    render() {
        const { selectProps, inputProps, onChange, inputMaxLength, idField } = this.props;
        const { inputLabelKey, ...rest } = inputProps;
        return (
            <div className="input-group" ref={this.inputGroupRef}>
                <FieldLabel
                    hideLabel
                    labelKey={selectProps.selectLabelKey}
                    mode="edit"
                    idField={`react-select-${idField}-input`}
                />
                <Select
                    id={idField}
                    instanceId={idField}
                    aria-labelledby={`label.${idField}`}
                    searchable={false}
                    onChange={(selectValue) => onChange(selectValue, inputProps.value)}
                    clearable={false}
                    placeholder=""
                    {...selectProps}
                />
                <FieldLabel hideLabel labelKey={inputProps.inputlabelkey} mode="edit" idField={`${idField}.number`} />
                <input
                    id={`${idField}.number`}
                    className="form-control"
                    type="text"
                    ref={this.inputRef}
                    maxLength={inputMaxLength}
                    inputlabelkey={inputLabelKey}
                    {...rest}
                    onChange={({ target }) => onChange(selectProps.value, target.value)}
                />
            </div>
        );
    }
}

export default SelectorInput;
